import { render, staticRenderFns } from "./CompanyCard.vue?vue&type=template&id=623f16b0&scoped=true"
import script from "./CompanyCard.vue?vue&type=script&lang=js"
export * from "./CompanyCard.vue?vue&type=script&lang=js"
import style0 from "./CompanyCard.vue?vue&type=style&index=0&id=623f16b0&prod&scoped=true&lang=css"
import style1 from "./CompanyCard.vue?vue&type=style&index=1&id=623f16b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623f16b0",
  null
  
)

export default component.exports